import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';

export const Root = styled('div')<{
	hidden: boolean;
	isNativePlatform?: boolean;
}>(({ theme, hidden, isNativePlatform }) => ({
	backgroundColor: theme.palette.neutral[0],
	width: '100%',
	height: '100%',
	display: 'grid',
	gridTemplateRows: isNativePlatform
		? 'max-content 1fr max-content'
		: 'max-content max-content 1fr',
	visibility: hidden ? 'hidden' : 'visible',
	maxWidth: MOBILE_CONTAINER_WIDTH,
	margin: 'auto',
	overflow: 'hidden',
}));

export const HeaderBlock = styled('div')(() => ({
	padding: 24,
	boxSizing: 'border-box',
}));

export const ContentBlock = styled('div')(() => ({
	width: '100%',
	height: '100%',
}));

export const FooterBlock = styled('div')(() => ({
	width: '100%',
	height: '100%',
}));
